import { useState } from "react";
import { Download, X, Share, Plus } from "lucide-react";
import { usePwaInstall } from "../hooks/usePwaInstall";

// Banner discreto sugerindo instalar o app. Aparece quando:
// - Não estamos rodando como PWA (display-mode != standalone)
// - O navegador disparou beforeinstallprompt (Chrome/Edge/Android), OU
//   estamos no iOS (Safari não dispara o evento — mostramos instruções)
// - O usuário não clicou "agora não" nos últimos 7 dias
//
// Posição bottom-left pra não brigar com o ChatFloating (bottom-right).
export function InstallPwaBanner() {
  const { podeInstalar, ios, temEventoNativo, instalar, adiar } = usePwaInstall();
  const [mostrarDicaIos, setMostrarDicaIos] = useState(false);

  if (!podeInstalar) return null;

  async function clicarInstalar() {
    if (temEventoNativo) {
      await instalar();
      // O hook lida com aceito/recusado. Em caso de recusa já adia 7 dias.
    } else if (ios) {
      setMostrarDicaIos(true);
    }
  }

  return (
    <>
      <div className="fixed bottom-5 left-5 z-40 max-w-[calc(100vw-2.5rem)] sm:max-w-sm">
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-700 p-3 flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-600 to-cyan-500 text-white flex items-center justify-center shrink-0">
            <Download size={18} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-800 dark:text-slate-100">
              Instalar RECDC OS
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
              {ios && !temEventoNativo
                ? "Adicione à tela inicial pra abrir como app, sem barra do navegador."
                : "Use como app: acesso rápido pela tela inicial e notificações."}
            </p>
            <div className="flex items-center gap-2 mt-2">
              <button
                type="button"
                onClick={clicarInstalar}
                className="text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-lg transition-colors"
              >
                {ios && !temEventoNativo ? "Como instalar" : "Instalar"}
              </button>
              <button
                type="button"
                onClick={adiar}
                className="text-xs font-medium text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 px-2 py-1.5"
              >
                Agora não
              </button>
            </div>
          </div>
          <button
            type="button"
            onClick={adiar}
            className="p-1 rounded text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700"
            aria-label="Fechar"
            title="Fechar (volta a aparecer em 7 dias)"
          >
            <X size={14} />
          </button>
        </div>
      </div>

      {mostrarDicaIos && (
        <div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-4"
          onClick={() => setMostrarDicaIos(false)}
        >
          <div
            className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-sm p-5"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-2 mb-3">
              <h3 className="font-semibold text-slate-800 dark:text-slate-100">
                Instalar no iPhone/iPad
              </h3>
              <button
                onClick={() => setMostrarDicaIos(false)}
                className="p-1 text-slate-400 hover:text-slate-600"
              >
                <X size={16} />
              </button>
            </div>
            <ol className="space-y-3 text-sm text-slate-700 dark:text-slate-200">
              <li className="flex items-start gap-2">
                <span className="w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 text-xs font-bold flex items-center justify-center shrink-0">1</span>
                <span className="flex-1">
                  Toque em <Share size={14} className="inline align-text-bottom mx-0.5" /> <strong>Compartilhar</strong> na barra do Safari.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 text-xs font-bold flex items-center justify-center shrink-0">2</span>
                <span className="flex-1">
                  Role e toque em <Plus size={14} className="inline align-text-bottom mx-0.5" /> <strong>Adicionar à Tela de Início</strong>.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 text-xs font-bold flex items-center justify-center shrink-0">3</span>
                <span className="flex-1">
                  Confirme em <strong>Adicionar</strong>. Pronto — abra pelo ícone na tela inicial.
                </span>
              </li>
            </ol>
            <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-4">
              Funciona apenas no Safari; não dá pelo Chrome/Firefox no iOS.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
